import { serializable, alias, primitive, list, object } from "serializr";

export class TeacherActivityModel {
    @serializable(alias("teacherId", primitive()))
    teacherId?: number;
    @serializable(alias("teacherName", primitive()))
    teacherName?: string;
    @serializable(alias("gradeName", primitive()))
    gradeName?: string;
    @serializable(alias("sectionName", primitive()))
    sectionName?: string;
    @serializable(alias("subjectName", primitive()))
    subjectName?: string;
    @serializable(alias("liveClassScheduled", primitive()))
    liveClassScheduled?: number;
    @serializable(alias("liveClassConducted", primitive()))
    liveClassConducted?: number;
    @serializable(alias("worksheetPosted", primitive()))
    worksheetPosted?: number;
    @serializable(alias("worksheetReviewed", primitive()))
    worksheetReviewed?: number;


}
export class ActivitySummaryModel {
    @serializable(alias("activityId", primitive()))
    activityId?: number;
    @serializable(alias("activityName", primitive()))
    activityName?: string;
    @serializable(alias("postedOn", primitive()))
    postedOn?: string;
    @serializable(alias("dueOn", primitive()))
    dueOn?: string;
    @serializable(alias("className", primitive()))
    className?: string;
    @serializable(alias("teacherName", primitive()))
    teacherName?: string;
    @serializable(alias("sectionName", primitive()))
    sectionName?: string;
    @serializable(alias("subjectName", primitive()))
    subjectName?: string;
    @serializable(alias("maxPoints", primitive()))
    maxPoints?: number;
    @serializable(alias("assignedCount", primitive()))
    assignedCount?: number;
    @serializable(alias("turnInCount", primitive()))
    turnInCount?: number;
    @serializable(alias("reviewedCount", primitive()))
    reviewedCount?: number;
}

export class ActivityDetailsModel {
    @serializable(alias("activityId", primitive()))
    activityId?: string;
    @serializable(alias("activityName", primitive()))
    activityName?: string;
    @serializable(alias("postedOn", primitive()))
    postedOn?: string;
    @serializable(alias("dueOn", primitive()))
    dueOn?: string;
    @serializable(alias("sectionName", primitive()))
    sectionName?: string;
    @serializable(alias("subjectName", primitive()))
    subjectName?: string;
    @serializable(alias("maxPoints", primitive()))
    maxPoints?: string;
    @serializable(alias("turnInDate", primitive()))
    turnInDate?: string;
    @serializable(alias("studentName", primitive()))
    studentName?: string;
    @serializable(alias("points", primitive()))
    points?: string;

}
